import Grid from './Grid/Grid';
import Toolbar from './Toolbar/Toolbar';
import Modal from './Modal/DynamicReport';

const DynamicReports = {
  Grid,
  Toolbar,
  Modal
}

export default DynamicReports;